import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.VehicleClass.Save.IRequest;
type Response = Api.Core.VehicleClass.Save.IResponse;
type Headers = Api.Core.VehicleClass.Save.IHeaders;
const url = '/api/ProductManagement/VehicleClass';
export default async function vehicleClassSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
